// extracted by mini-css-extract-plugin
module.exports = {"block":"socials-module--block--1RZ3U","logo":"socials-module--logo--1tzC5"};